module.exports = __webpack_public_path__ + "public/images/flags/Flag_of_Maldives.88708be3d20b40ef63a7a0311899602e.png";